module.exports = __webpack_public_path__ + "img/personal-center-slide-select-right.f64ef571.svg";